import { useRef, useEffect, useCallback } from 'react';
import { Middleware } from 'swr';

// This is a SWR middleware for keeping the data even if key changes.
export const laggy: Middleware = useSWRNext => {
  return (key, fetcher, config) => {
    // Use a ref to store previous returned data.
    const laggyDataRef = useRef<any>();

    // Actual SWR hook.
    const swr = useSWRNext(key, fetcher, config);

    useEffect(() => {
      // Update ref if data is not undefined.
      if (swr.data !== undefined) {
        laggyDataRef.current = swr.data;
      }
    }, [swr.data]);

    // Expose a method to clear the laggy data, if any.
    const resetLaggy = useCallback(() => {
      laggyDataRef.current = undefined;
    }, []);

    return Object.defineProperties(swr, {
      data: {
        enumerable: true,
        value: swr.data === undefined ? laggyDataRef.current : swr.data,
      },
      isLagging: {
        enumerable: true,
        get() {
          return swr.data === undefined && laggyDataRef.current !== undefined;
        },
      },
      resetLaggy: {
        enumerable: true,
        value: resetLaggy,
      },
    });
  };
};
